// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import doctplEntity from './entities/doctpl.json';
import doctplMenu from '../pages/doctpl/menu.json';
import doctplFullForm from '../pages/doctpl/forms/full.json';
import doctplContextForm from '../pages/doctpl/forms/context.json';
import doctplMiniForm from '../pages/doctpl/forms/mini.json';
import doctplLookupForm from '../pages/doctpl/forms/lookup.json';
import doctplTableView from '../pages/doctpl/views/table.json';
import doctplStagesView from '../pages/doctpl/views/stages.json';
import doctplCardsView from '../pages/doctpl/views/cards.json';
import doctplInlineView from '../pages/doctpl/views/inline.json';
import doctplBacklogView from '../pages/doctpl/views/backlog.json';
import doctplSplitView from '../pages/doctpl/views/split.json';
import doctplCalendarView from '../pages/doctpl/views/calendar.json';
import doctplDashboardView from '../pages/doctpl/views/dashboard.json';

/** Тип запису «Шаблон» зі сторінками пакета: меню, форми та подання з pages/doctpl/. */
export const doctplDefinition: IRecordTypeDefinition = {
  ...doctplEntity,
  views: assembleViewSet({
      table: doctplTableView,
      stages: doctplStagesView,
      cards: doctplCardsView,
      inline: doctplInlineView,
      backlog: doctplBacklogView,
      split: doctplSplitView,
      calendar: doctplCalendarView,
      dashboard: doctplDashboardView,
  }),
  form: doctplFullForm,
  forms: { full: doctplFullForm, context: doctplContextForm, mini: doctplMiniForm, lookup: doctplLookupForm },
  menu: doctplMenu,
} as IRecordTypeDefinition;
